export default "__VITE_ASSET__DbaY5PNh__"